const BounceLoader = () => {
  return (
    <div className="center_child">
      <div className="relative z-20">
        <div className="flex text-center justify-center space-x-2 animate-bounce">
          <div className="w-8 h-8 bg-green-800 rounded-full"></div>
        </div>
      </div>
    </div>
  );
};

export default BounceLoader;
